module.exports = __webpack_public_path__ + "img/15.664b4416.png";